// ProjectChip — clickable inline pill that opens the project detail modal.
// Designed to sit under an assistant turn, in a horizontal flex-wrap row.

interface Props {
  name: string;
  onOpen: (name: string) => void;
}

export function ProjectChip({ name, onOpen }: Props) {
  return (
    <button
      type="button"
      onClick={() => onOpen(name)}
      title={name}
      className="inline-flex items-center gap-1 rounded-full border border-border bg-surface-2 px-2.5 py-1 text-[12px] text-text-sec transition hover:border-emerald-500 hover:bg-emerald-50 hover:text-emerald-900"
    >
      <svg width={10} height={10} viewBox="0 0 16 16" fill="none" className="shrink-0">
        <path
          d="M8 1.5a4.5 4.5 0 0 0-4.5 4.5c0 3.5 4.5 8.5 4.5 8.5s4.5-5 4.5-8.5A4.5 4.5 0 0 0 8 1.5z"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinejoin="round"
        />
        <circle cx="8" cy="6" r="1.5" stroke="currentColor" strokeWidth="1.4" />
      </svg>
      <span className="max-w-[160px] truncate">{name}</span>
    </button>
  );
}

export function ProjectChipRow({ projects, onOpen }: { projects: string[]; onOpen: (name: string) => void }) {
  if (projects.length === 0) return null;
  return (
    <div className="mt-2 flex flex-wrap gap-1.5">
      {projects.map((name) => (
        <ProjectChip key={name} name={name} onOpen={onOpen} />
      ))}
    </div>
  );
}
